import React, { useState } from 'react';
import { processCallbackSingle, sendLoginPayload } from 'account-portal-library/lib/emailSignIn';

import AppVars from './../../AppVars';
import Logger from '../../Logger.js';

import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import LoadingGif from '../../static/images/loading.gif';
import Logo from '../../static/images/TO/toyota-logo.svg';

let appVars = AppVars.getInstance();
let logger = Logger.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked";

export function maskPhoneNumber(phoneNumber) {
    // Remove all non-digits from the phone number string
    let digitsOnly = phoneNumber.replace(/\D/g, '');

    // Replace all but the last 4 digits with asterisks
    let masked = '';
    for (let i = 0; i < digitsOnly.length - 2; i++) {
        masked += '×';
    }

    masked += digitsOnly.slice(-2);

    // Insert dashes or spaces between the masked sections of the phone number
    let formatted = '';
    if (masked.length === 10) {
        formatted = "+× " + masked;
    } else if (masked.length === 11) {
        formatted = "+" + masked.slice(0, 1) + ' ' + masked.slice(1);
    } else {
        formatted = masked;
    }

    return formatted;
}

const MfaSelectPage = ({ style = 'TO', savePayload, payload, saveStep, phoneNumber }) => {
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');

    const chooseCollection = async () => {
        const url = appVars.getBaseUrl() + '/' + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
        const headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
        }
        const params = {
            'authIndexType': 'service',
            'authIndexValue': appVars.getEmailSignInTree()
        }
        let choicePayload = processCallbackSingle(payload, selectedOption)
        const choiceResponse = await sendLoginPayload(choicePayload, url, headers, params)
        handleLoginResponse(choiceResponse)
    }

    const handleLoginResponse = (loginResponse) => {
        if (validateForm(loginResponse.status)) {
            handleSuccess(loginResponse);
        } else {
            handleFailure(loginResponse);
        }
    }

    const validateForm = (status) => {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    const handleSuccess = async (loginResponse) => {
        logger.log("test", loginResponse)
        logger.log("test", loginResponse.response.callbacks)
        if (loginResponse.response.callbacks == null) {
            console.log("failure or session expired")
            window.location.replace(appVars.getUnknownErrorURL(style));
        } else {
            setLoading(false)
            savePayload(loginResponse)
            saveStep("TEXT_CODE")
        }
    }

    const handleFailure = (loginResponse) => {
        var failureUrl = loginResponse.failureUrl
        //If invalid credentials
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            setLoading(false)
            window.location.replace(ACCOUNT_LOCKED_URL);
        }
        else {
            if (loginResponse.message == 'Session has timed out') {
                window.location.href = "/";
            } else {
                console.log(loginResponse.message)
                window.location.replace(appVars.getUnknownErrorURL(style));
            }
        }
    }

    const goNext = async () => {
        if(selectedOption !== ""){
            setLoading(true);
            chooseCollection();
        }
    }

    return <div className="login-wrapper" >
        <div className="relative login-box">
            <img src={Logo} className="login-logo__TO absolute" alt="Toyota Owners"></img>
            <div className="title__TO left">Select an option</div>
            <div className="sign-in-mfa-grid">
                <div className="sign-in-subtitle-left sign-in-subtitle">Your security is important to us, please select an option below to verify your identity. </div>
            </div>

            <div className='select-form'>
                <input type="radio" id="text" name="mfa_radio" value="0" onClick={(e) => { setSelectedOption(e.target.value) }} />
                <label className='mfa_input_label' htmlFor="text">Text:{maskPhoneNumber(phoneNumber ? phoneNumber : "")}</label><br />
                <input type="radio" id="call" name="mfa_radio" value="1" onClick={(e) => { setSelectedOption(e.target.value) }} />
                <label className='mfa_input_label' htmlFor="call">Call:{maskPhoneNumber(phoneNumber ? phoneNumber : "")}</label><br />
            </div>
            <div className='mfa-button-group'>
                <Button bsPrefix="login-button-outline__TO button-duration" type="submit" onClick={() => window.location.href = "https://www.toyota.com/support/contact-us/"}>Get help with login</Button>
                <Button bsPrefix={selectedOption !== "" ? "login-button__TO" : "login-button-disabled__TO"} type="submit" onClick={goNext}>Next Step</Button>
            </div>
        </div>
        <Image data-testid="loadingGIF" className={`working ${loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
    </div>
}

export default MfaSelectPage; 